import { useContext } from 'react';
import { PortalProvider } from '@cbhq/cds-web/overlays/PortalProvider';
import { MediaQueryProvider } from '@cbhq/cds-web/system/MediaQueryProvider';
import { ThemeProvider } from '@cbhq/cds-web/system/ThemeProvider';
import { PortalProvider as PortalProviderV7 } from '@cbhq/cds-web/v7/overlays/PortalProvider';
import { ThemeProvider as ThemeProviderV7 } from '@cbhq/cds-web/v7/system/ThemeProvider';

import { coinbaseDenseTheme } from ':support/providers/coinbaseDenseTheme';
import { SpectrumContext } from ':support/providers/SpectrumProvider';

type CDSProviderProps = {
  children: React.ReactNode;
};

export function CDSProvider({ children }: CDSProviderProps) {
  const { spectrum } = useContext(SpectrumContext);

  return (
    <MediaQueryProvider>
      <ThemeProvider theme={coinbaseDenseTheme} activeColorScheme={spectrum}>
        {/*
          TODO: Remove v7 providers once all dependencies are migrated to CDS v8.
          Currently needed for @cbhq/identity-navigation which uses v7 NavigationBar internally.
          The v7 ThemeProvider and PortalProvider ensure proper styling and overlay behavior
          for components that still depend on v7 CDS.
        */}
        <ThemeProviderV7 spectrum={spectrum}>
          <PortalProvider>
            <PortalProviderV7>{children}</PortalProviderV7>
          </PortalProvider>
        </ThemeProviderV7>
      </ThemeProvider>
    </MediaQueryProvider>
  );
}
